// Navigation only: the server remains the authority for platform access.
export const getStaffLandingPath = (user) => {
  if (user?.role === 'platform_owner' || user?.platform_owner === true || user?.platform_staff === true) return '/platform';
  if (user?.role === 'cashier') return '/pos';
  if (user?.role === 'pharmacist') return '/customers/records';
  return '/dashboard';
};